// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__2zTpQ","modal":"Modal_modal__2hm7N","slide-down":"Modal_slide-down__32OVX"};